/* Copyright (c) 2020-present CloudIO Inc */

import { useRef, useEffect } from 'react';

export default function useMounted(initialValue = true): { current: boolean } {
  const ref = useRef(initialValue);

  useEffect(() => {
    ref.current = true;
    return () => {
      ref.current = false;
    };
  }, []);

  return ref;
}
